var _SchemaSpecRegistry_spec;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { Schema } from 'prosemirror-model';
export class SchemaSpecRegistry {
    constructor(topNode) {
        _SchemaSpecRegistry_spec.set(this, void 0);
        __classPrivateFieldSet(this, _SchemaSpecRegistry_spec, { topNode, nodes: {}, marks: {} }, "f");
    }
    addNode(name, spec) {
        __classPrivateFieldGet(this, _SchemaSpecRegistry_spec, "f").nodes[name] = spec;
        return this;
    }
    addMark(name, spec) {
        __classPrivateFieldGet(this, _SchemaSpecRegistry_spec, "f").marks[name] = spec;
        return this;
    }
    createSchema() {
        return new Schema(__classPrivateFieldGet(this, _SchemaSpecRegistry_spec, "f"));
    }
}
_SchemaSpecRegistry_spec = new WeakMap();
